import { render } from "./AssignRoleDialog.vue?vue&type=template&id=3360618c&scoped=true"
import script from "./AssignRoleDialog.vue?vue&type=script&lang=js"
export * from "./AssignRoleDialog.vue?vue&type=script&lang=js"

import "./AssignRoleDialog.vue?vue&type=style&index=0&id=3360618c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3360618c"]])

export default __exports__